// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__2JaUi","box":"Loading_box__3IH1P","loader":"Loading_loader__fHWHo","animateLoading":"Loading_animateLoading__35uV2","span":"Loading_span__1yP5E"};